import React, {useContext, useState} from 'react'
import {StateContext} from "../../context/GlobalState.jsx";
import {Col, Container, Row} from "react-bootstrap";
import Pages from "../Pagination/allPagination.jsx";
import PagesURL from "../Pagination/allPaginationURL.jsx";
import {Helmet} from "react-helmet";
import {GetText} from "../../context/text";



function Filter(props) {

    let text = GetText();
    let {models} = useContext(StateContext);


    const [modelId, setModelId] = useState(0);


    const filterModel = (ids) => {
        setModelId(ids);
    }


    return (
        <div>
            <Helmet>
                <title>{text.Catalog.title + ' - ' + text.Header.name} - zapauto.com.ua</title>
                <meta name="description" content={
                    text.Catalog.title + ": " + models.map((model) => model.NAME_GROUP + " ")}/>
                <meta name="keywords"
                      content={ models.map((model) => model.NAME_GROUP + " ") } />
            </Helmet>
            <Container>
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>

                        <div className="cars">
                            <Container>
                                <Row>
                                    {
                                        models.map((model, i) => <Col xs={6} sm={4} md={2} key={model.ID}>

                                            <button className="add-cart-btn full-width"    onClick={() => filterModel(model.ID)} >{model.NAME_GROUP}</button>

                                        </Col>)
                                    }
                                </Row>
                            </Container>
                        </div>


                    </Col>
                </Row>
            </Container>
            {props.pageURL ? <PagesURL pageURL={props.pageURL} /> : <Pages modelId={modelId}  />}
        </div>
    )
}

export default Filter
